import { CylinderGeometry, Group, Mesh, MeshBasicMaterial, Raycaster, SphereGeometry, Vector3 } from 'three';

import { Bvh, Text as DreiText, Billboard } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { GroupProps, useFrame } from '@react-three/fiber';
import * as React from 'react';

const pointDist = 5;
const raycaster = new Raycaster();
const origVec = new Vector3();
const dirVec = new Vector3();
const cyl = new CylinderGeometry(0.02, 0.02);
const sph = new SphereGeometry(0.25, 10, 10);
const basOrig = new MeshBasicMaterial({ color: 'yellow', wireframe: true });
const basHit = new MeshBasicMaterial({ color: 'red', wireframe: true });
const tra = new MeshBasicMaterial({
  color: 'blue',
  wireframe: true,
  // transparent: true,
  // opacity: 0.25,
});

function Ray(props: { target: React.MutableRefObject<Group> }) {
  const { target } = props;
  const objRef = React.useRef<Group>(null!);
  const origMesh = React.useRef<Mesh>(null!);
  const origText = React.useRef<typeof DreiText>(null!);
  const hitMesh = React.useRef<Mesh>(null!);
  const cylinderMesh = React.useRef<Mesh>(null!);

  React.useEffect(() => {
    // objRef.current.rotation.x = Math.random() * 10;
    // objRef.current.rotation.y = Math.random() * 10;
    origMesh.current.position.set(pointDist, 0, 0);
    // hitMesh.current.scale.multiplyScalar(0.5);
  }, []);

  // const xDir = Math.random() - 0.5;
  // const yDir = Math.random() - 0.5;

  const [origStr, setOrigStr] = React.useState('');

  useFrame((_, delta) => {
    const obj = objRef.current;
    // obj.rotation.x += xDir * delta;
    // obj.rotation.y += yDir * delta;
    obj.rotation.y += delta;
    // origMesh.current.position.set(pointDist, 1, 0);
    // origMesh.current.position.y = -1;
    // origMesh.current.updateMatrixWorld();
    origVec.setFromMatrixPosition(origMesh.current.matrixWorld);
    dirVec.copy(origVec).multiplyScalar(-1).normalize();
    raycaster.set(origVec, dirVec);
    raycaster.firstHitOnly = true;
    const res = raycaster.intersectObject(target.current, true);
    const hit = res[0];
    const length = hit ? hit.distance : pointDist;
    setOrigStr(
      `(${origVec.x.toFixed()}, ${origVec.y.toFixed()}, ${origVec.z.toFixed()}) (${dirVec.x.toFixed()}, ${dirVec.y.toFixed()}, ${dirVec.z.toFixed()}) ${length.toFixed(
        2
      )}`
    );
    hitMesh.current.position.setX(pointDist - length);
    cylinderMesh.current.position.setX(pointDist - length + length / 2);
    cylinderMesh.current.rotation.set(0, 0, Math.PI / 2);
    cylinderMesh.current.scale.set(1, length, 1);

    // const posHit = objRef.current.worldToLocal(hit.point);
    // const normal = objRef.current.worldToLocal(hit.normal!);
    // // hitMesh.current.position.set(pointDist - length, 0, 0);
    // hitMesh.current.position.set(posHit.x, posHit.y, posHit.z);
    // cylinderMesh.current.position.set(posHit.x, posHit.y, posHit.z);
    // cylinderMesh.current.lookAt(normal);
    // cylinderMesh.current.scale.set(1, length, 1);
  });

  return (
    <group ref={objRef}>
      <mesh ref={origMesh} geometry={sph} material={basOrig}>
        <Billboard>
          <DreiText position={[0, -1, 0]} ref={origText} fontSize={0.5}>
            {origStr}
          </DreiText>
        </Billboard>
      </mesh>
      <mesh ref={hitMesh} geometry={sph} material={basHit} />
      <mesh ref={cylinderMesh} geometry={cyl} material={tra} />
    </group>
  );
}

function Rays(props: GroupProps) {
  const ref = React.useRef<Group>(null!);
  // const { count } = useControls({ count: { value: 1, min: 0, max: 500 } });
  return (
    <>
      <group ref={ref} {...props} />
      {Array.from({ length: 1 }, (_, id) => (
        <Ray key={id} target={ref} />
      ))}
    </>
  );
}

export type Props = {};

function App(props: Props) {
  const {} = props;

  return (
    <>
      <Canvas
        // camera-position-z={100}
        camera-far={100}
        camera={{ position: [0, 0, 7] }}
        style={{ height: '30vh', marginBottom: '2rem' }}
      >
        <color attach="background" args={['#202025']} />
        <Bvh>
          <Rays>
            <mesh>
              <sphereGeometry args={[1, 10, 10]} />
              <meshBasicMaterial color={0x00ff00} wireframe />
            </mesh>
          </Rays>
        </Bvh>
        {/* <OrbitControls /> */}
      </Canvas>
    </>
  );
}

export default React.memo(App);
